export default "__VITE_ASSET__BrJzx43S__"